/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function clamp(value, min, max) {
  if (isNaN(value)) {
    return value;
  }

  var minUndefined = typeof min === 'undefined';
  var maxUndefined = typeof max === 'undefined';

  if (minUndefined && maxUndefined) {
    return value;
  }

  if (minUndefined) {
    if (!maxUndefined) {
      return value > max ? max : value;
    }
  }

  if (maxUndefined) {
    if (!minUndefined) {
      return value < min ? min : value;
    }
  }

  if (min > max) {
    return clamp(value, max, min);
  }

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

var _default = clamp;
exports.default = _default;